<template>
    <v-layout style="height: 100vh; width: 100vw;">
      <v-navigation-drawer
        nav
        elevation="2"
        v-model="drawer"
        :rail="rail"
        width="300"
        @click="rail = false"
        color="sideBarColor"
      >
      <div class="flex-grow-1"> 
        <div class="sticky-header">
          <v-list-item nav>
            <div v-if="rail == false" class="d-flex flex-row justify-start align-center mt-2 mb-2">
              <div>
                <v-img :width="65" class="ml-6" src="../assets/aums-tab-logo.png"/>
              </div>
              <div class="text-h4 font-weight-black ml-4" style="color: #ca8a04;">AUMS</div>
            </div>
            <v-img v-else class="mt-2" src="../assets/aums-tab-logo.png"></v-img>
          </v-list-item>  
        </div>
       
        <!-- Menu for Admin -->
        <v-list v-if="$store.state.currentRole.id == 1" :class="rail ? '': 'pl-5'" class="mr-n4" density="comfortable" nav>
          <v-list-subheader v-if="!rail" class="text-body-2" color="routesColor">MAIN MENU</v-list-subheader>
          <v-list-item prepend-icon="mdi-view-dashboard" rounded="lg" router :to="'dashboard'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/dashboard') }">
             <v-list-item-title class="text-body-2">Dashboard</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-account-check" rounded="lg" router :to="'accounts-verification'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/accounts-verification') }">
             <v-list-item-title class="text-body-2">Accounts Verification</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-account-cog" rounded="lg" router :to="'accounts-management'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/accounts-management') }">
             <v-list-item-title class="text-body-2">Accounts Management</v-list-item-title>
          </v-list-item>
          <v-list-subheader v-if="!rail" class="text-body-2" color="routesColor">OTHERS</v-list-subheader>
          <v-list-item prepend-icon="mdi-bullhorn" rounded="lg" router :to="'announcements'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/announcements') }">
             <v-list-item-title class="text-body-2">Announcements</v-list-item-title>
          </v-list-item>
        </v-list>

        <!-- Menu for VP -->
        <v-list v-if="$store.state.currentRole.id == 2" :class="rail ? '': 'pl-5'" class="mr-n4" density="comfortable" nav>
          <v-list-subheader v-if="!rail" class="text-body-2" color="routesColor">MAIN MENU</v-list-subheader>
          <v-list-item prepend-icon="mdi-view-dashboard" rounded="lg" router :to="'dashboard'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/dashboard') }">
             <v-list-item-title class="text-body-2">Dashboard</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-calendar-multiselect" rounded="lg" router :to="'schedules'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/schedules') }">
             <v-list-item-title class="text-body-2">Schedules</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-archive-arrow-down-outline" rounded="lg" router :to="'approval-workload'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/approval-workload') }">
             <v-list-item-title class="text-body-2">Faculty Workload</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-chart-timeline" rounded="lg" router :to="'reports'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/reports') }">
             <v-list-item-title class="text-body-2">Reports</v-list-item-title>
          </v-list-item>
        </v-list>

        <!-- Menu for the Director for Curriculum -->
        <v-list v-if="$store.state.currentRole.id == 3" :class="rail ? '': 'pl-5'" class="mr-n4" density="comfortable" nav>
          <v-list-subheader v-if="!rail" class="text-body-2" color="routesColor">MAIN MENU</v-list-subheader>
          <v-list-item prepend-icon="mdi-view-dashboard" rounded="lg" router :to="'dashboard'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/dashboard') }">
             <v-list-item-title class="text-body-2">Dashboard</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-archive-arrow-down-outline" rounded="lg" router :to="'pre-approval-workload'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/pre-approval-workload') }">
             <v-list-item-title class="text-body-2">Faculty Workload</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-folder-arrow-down-outline" rounded="lg" router :to="'faculty-course-load'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/faculty-course-load') }">
             <v-list-item-title class="text-body-2">Faculty Course Load</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-note-check" rounded="lg" router :to="'approved-tq-tos'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/approved-tq-tos') }">
             <v-list-item-title class="text-body-2">Approved TOS and TQ</v-list-item-title>
          </v-list-item>
        </v-list>

        <!-- Menu for Dean -->
        <v-list v-if="$store.state.currentRole.id == 4" :class="rail ? '': 'pl-5'" class="mr-n4" density="comfortable" nav>
          <v-list-subheader v-if="!rail" class="text-body-2" color="routesColor">MAIN MENU</v-list-subheader>
          <v-list-item prepend-icon="mdi-view-dashboard" rounded="lg" router :to="'dashboard'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/dashboard') }">
             <v-list-item-title class="text-body-2">Dashboard</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-archive-arrow-down-outline" rounded="lg" router :to="'recommending-approval-workload'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/recommending-approval-workload') }">
             <v-list-item-title class="text-body-2">Faculty Workload</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-file-find" rounded="lg" router :to="'compliance-approval'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/compliance-approval') }">
             <v-list-item-title class="text-body-2">Compliance Approval</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-file-check" rounded="lg" router :to="'compliance-checking'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/compliance-checking') }">
             <v-list-item-title class="text-body-2">Compliance Checking</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-chart-timeline" rounded="lg" router :to="'reports'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/reports') }">
             <v-list-item-title class="text-body-2">Compliance Reports</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-note-text" rounded="lg" router :to="'mentoring-and-commitment'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/mentoring-and-commitment') }">
             <v-list-item-title class="text-body-2">Mentoring & Commitment</v-list-item-title>
          </v-list-item>
          <v-list-group>
            <template v-slot:activator="{ props }">
              <v-list-item
                v-bind="props"
                prepend-icon="mdi-book-education"
              >
              <v-list-item-title class="text-subtitle-2">Obedization</v-list-item-title>
            </v-list-item>
            </template>
              <v-list-item rounded="lg" router :to="'program-outcomes'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/program-outcomes') }">
                <v-list-item-title class="text-body-2">Program Outcomes</v-list-item-title>
              </v-list-item>
              <v-list-item rounded="lg" router :to="'course-outcomes'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/course-outcomes') }">
                <v-list-item-title class="text-body-2">Course Outcomes</v-list-item-title>
              </v-list-item>
          </v-list-group>
          <v-list-item v-if="$store.state.user.office.id == 7" prepend-icon="mdi-calendar-expand-horizontal-outline" rounded="lg" router :to="'sets-deadlines'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/sets-deadlines') }">
             <v-list-item-title class="text-body-2">Sets Deadlines</v-list-item-title>
          </v-list-item>
        </v-list>

        <!-- Menu for Program or Department Chair -->
        <v-list v-if="$store.state.currentRole.id == 5" :class="rail ? '': 'pl-5'" class="mr-n4" density="comfortable" nav>
          <v-list-subheader v-if="!rail" class="text-body-2" color="routesColor">MAIN MENU</v-list-subheader>
          <v-list-item prepend-icon="mdi-view-dashboard" rounded="lg" router :to="'dashboard'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/dashboard') }">
             <v-list-item-title class="text-body-2">Dashboard</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-folder-arrow-down-outline" rounded="lg" router :to="'faculty-course-load'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/faculty-course-load') }">
             <v-list-item-title class="text-body-2">Faculty Course Load</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-archive-arrow-down-outline" rounded="lg" router :to="'prepare-faculty-workload'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/prepare-faculty-workload') }">
             <v-list-item-title class="text-body-2">Faculty Workload</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-file-find" rounded="lg" router :to="'compliance-review'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/compliance-review') }">
             <v-list-item-title class="text-body-2">Compliance Review</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-file-check" rounded="lg" router :to="'compliance-checking'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/compliance-checking') }">
             <v-list-item-title class="text-body-2">Compliance Checking</v-list-item-title>
          </v-list-item>
          <v-list-group>
            <template v-slot:activator="{ props }">
              <v-list-item
                v-bind="props"
                prepend-icon="mdi-book-education"
              >
              <v-list-item-title class="text-subtitle-2">Obedization</v-list-item-title>
            </v-list-item>
            </template>
              <v-list-item rounded="lg" router :to="'program-outcomes'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/program-outcomes') }">
                <v-list-item-title class="text-body-2">Program Outcomes</v-list-item-title>
              </v-list-item>
              <v-list-item rounded="lg" router :to="'course-outcomes'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/course-outcomes') }">
                <v-list-item-title class="text-body-2">Course Outcomes</v-list-item-title>
              </v-list-item>
          </v-list-group>
          <v-list-subheader v-if="!rail" class="text-body-2" color="routesColor">OTHERS</v-list-subheader>
          <v-list-item prepend-icon="mdi-book-settings-outline" rounded="lg" router :to="'courses'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/courses') }">
             <v-list-item-title class="text-body-2">Courses</v-list-item-title>
          </v-list-item>
        </v-list>

        <!-- Menu for VPAA Staff -->
        <v-list v-if="$store.state.currentRole.id == 6" :class="rail ? '': 'pl-5'" class="mr-n4" density="compact" nav>
          <v-list-subheader v-if="!rail" class="text-body-2" color="routesColor">MAIN MENU</v-list-subheader>
          <v-list-item prepend-icon="mdi-view-dashboard" rounded="lg" router :to="'dashboard'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/dashboard') }">
             <v-list-item-title class="text-body-2">Dashboard</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-account-check" rounded="lg" router :to="'accounts-verification'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/accounts-verification') }">
             <v-list-item-title class="text-body-2">Accounts Verification</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-school" rounded="lg" router :to="'semester-schoolyear'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/semester-schoolyear') }">
             <v-list-item-title class="text-body-2">Semester and Schoolyear</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-briefcase-download" rounded="lg" router :to="'rep-load'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/rep-load') }">
             <v-list-item-title class="text-body-2">RDE Load Release</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-briefcase" rounded="lg" router :to="'faculty-workload'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/faculty-workload') }">
             <v-list-item-title class="text-body-2">Faculty Workload</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-calendar-multiselect" rounded="lg" router :to="'schedules'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/schedules') }">
             <v-list-item-title class="text-body-2">Schedules</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-note-text" rounded="lg" router :to="'mentoring-and-commitment'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/mentoring-and-commitment') }">
             <v-list-item-title class="text-body-2">Mentoring & Commitment</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-camera-metering-matrix" rounded="lg" router :to="'recommendation-and-compliance'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/recommendation-and-compliance') }">
             <v-list-item-title class="text-body-2">Compliance Matrix</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-chart-timeline" rounded="lg" router :to="'reports'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/reports') }">
             <v-list-item-title class="text-body-2">Reports</v-list-item-title>
          </v-list-item>
          <v-list-subheader v-if="!rail" class="text-body-2" color="routesColor">OTHERS</v-list-subheader>
          <v-list-item prepend-icon="mdi-folder-multiple" rounded="lg" router :to="'compliances'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/compliances') }">
             <v-list-item-title class="text-body-2">Compliances</v-list-item-title>
          </v-list-item>
        </v-list>   

        <!-- Menu for REP Staff -->
        <v-list v-if="$store.state.currentRole.id == 7" :class="rail ? '': 'pl-5'" class="mr-n4" density="comfortable" nav>
          <v-list-subheader v-if="!rail" class="text-body-2" color="routesColor">MAIN MENU</v-list-subheader>
          <v-list-item prepend-icon="mdi-view-dashboard" rounded="lg" router :to="'dashboard'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/dashboard') }">
             <v-list-item-title class="text-body-2">Dashboard</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-briefcase-download" rounded="lg" router :to="'rep-load'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/rep-load') }">
             <v-list-item-title class="text-body-2">RDE Unit Loading</v-list-item-title>
          </v-list-item>
        </v-list>

        <!-- Menu for Registrar -->
        <v-list v-if="$store.state.currentRole.id == 8" :class="rail ? '': 'pl-5'" class="mr-n4" density="comfortable" nav>
          <v-list-subheader v-if="!rail" class="text-body-2" color="routesColor">MAIN MENU</v-list-subheader>
          <v-list-item prepend-icon="mdi-view-dashboard" rounded="lg" router :to="'dashboard'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/dashboard') }">
             <v-list-item-title class="text-body-2">Dashboard</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-chart-timeline" rounded="lg" router :to="'reports'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/reports') }">
             <v-list-item-title class="text-body-2">Reports</v-list-item-title>
          </v-list-item>
        </v-list>

        <!-- Menu for Faculty -->
        <v-list v-if="$store.state.currentRole.id == 9" :class="rail ? '': 'pl-5'" class="mr-n4" density="comfortable" nav>
          <v-list-subheader v-if="!rail" class="text-body-2" color="routesColor">MAIN MENU</v-list-subheader>
          <v-list-item prepend-icon="mdi-view-dashboard" rounded="lg" router :to="'dashboard'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/dashboard') }">
             <v-list-item-title class="text-body-2">Dashboard</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-folder-arrow-down-outline" rounded="lg" router :to="'my-course-load'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/my-course-load') }">
             <v-list-item-title class="text-body-2">My Course Load</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-file-upload" rounded="lg" router :to="'rep-load-release'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/rep-load-release') }">
             <v-list-item-title class="text-body-2">RDE Load Release</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-briefcase" rounded="lg" router :to="'my-workload'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/my-workload') }">
             <v-list-item-title class="text-body-2">My Workload</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-file-upload" rounded="lg" router :to="'compliance-submission'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/compliance-submission') }">
             <v-list-item-title class="text-body-2">Compliance Submission</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-file-check" rounded="lg" router :to="'compliance-checked'" class="mb-3 pa-2" :class="{ 'solid-bg': $route.path.includes('/compliance-checked') }">
             <v-list-item-title class="text-body-2">Compliance Checked</v-list-item-title>
          </v-list-item>
        </v-list>
        </div>

        <!-- Fixed v-select at the bottom -->
        <div v-if="rail == false" class="sticky-footer pa-4">
          <v-select
            v-model="$store.state.currentRole"
            :items="$store.state.user.roles"
            @update:model-value="changeRole"
            item-title="name"
            item-value="id"
            label="Current Role"
            variant="outlined"
            return-object
            dense
            class="w-100"
          ></v-select>
        </div>
      </v-navigation-drawer>
        <v-app-bar app color="secondary" :elevation="4">
          <template v-slot:prepend>
            <v-app-bar-nav-icon @click="drawer ? rail = !rail : rail = false; drawer = true"></v-app-bar-nav-icon>
          </template>
          <v-app-bar-title class="font-weight-medium">{{ $route.meta.title }}</v-app-bar-title>
          <v-app-bar-title class="font-weight-bold"></v-app-bar-title>
          <template v-slot:append>
            <v-btn id="notif-activator" icon>
              <v-badge v-if="notificationCount > 0" color="red" size='x-small' :content="notificationCount">
                <v-icon class="pa-2">mdi-bell</v-icon>
              </v-badge>
              <div v-else>
                <v-icon class="pa-2">mdi-bell</v-icon>
              </div>
            </v-btn>
            <v-menu activator="#notif-activator">
              <v-card color="secondary" class="" width="500">
                  <v-card-text>
                     <v-row dense style="max-height: 450px; overflow-y: auto;">
                        <v-col v-for="notif in notificationData" :key="notif" cols="12">
                          <v-card @click="markedAsRead(notif)" router :to="notif.routes_to" :color="notif.marked_as_read ? '' : 'green-lighten-4'">
                            <v-card-text>
                                <div class="font-weight-bold d-flex align-center ga-1">
                                  <v-icon v-if="notif.marked_as_read == false">mdi-email-outline</v-icon>
                                  <v-icon v-else>mdi-email-open-outline</v-icon>
                                  <span v-html="notif.title"></span></div>
                                <div class="mt-1 text-body-2" v-html="notif.details"></div>
                                <div class="text-caption mt-3">
                                    {{ formatDateTimeFromNow(notif.datecreated) }} - {{ notif.notifFrom.fname }} {{ notif.notifFrom.lname }}, {{ notif.notifFrom.designation }}
                                </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-divider class="ma-1"></v-divider>
                        <v-col cols="12">
                          <v-btn block>View all notification</v-btn>
                        </v-col>
                     </v-row>
                  </v-card-text>
              </v-card>
            </v-menu>
            <v-btn
              @click="showChangeSemesterSchoolyearDialog()"
              color="darkGreen"
              elevation="0"
              rounded="xl"
              height="50"
              variant="tonal"
              class="ml-2"
            >
            <!-- <span class="pa-2 blur text-body-2">Administrator</span> -->
            <v-avatar>
              <v-icon color="darkGreen" size="25">mdi-school-outline</v-icon>
            </v-avatar>
              <span class="blur font-weight-bold" style="font-size: small;">{{ $store.state.semester_schoolyear?.semester }} of S.Y. {{ $store.state.semester_schoolyear?.schoolyear }}</span>
            </v-btn>
            
          <v-btn 
            id="menu-activator"
            bg-color="#5B7459"
            elevation="0"
            rounded="xl"
            height="50"
          >
          <v-avatar>
            <v-img v-if="!$store.state.user.picUrl" src="../assets/profile-pic.png"></v-img>
            <v-img v-else :src="currentImage" @error="onImageError"></v-img>
          </v-avatar>
          <!-- <span class="pa-2 blur text-body-2">Administrator</span> -->
           <span class="d-flex blur flex-column text-left text-truncate">
            <span class="blur text-body-2 px-2"> {{ $store.state.user.fname }} {{ $store.state.user.mname ? $store.state.user.mname[0] + '.' : '' }} {{ $store.state.user.lname }} {{ $store.state.user.suffix ? $store.state.user.suffix : '' }}</span>
            <span class="blur text-caption px-2 font-weight-light mt-n1">{{ $store.state.user.designation ? $store.state.user.designation : $store.state.user.position?.name }}</span>
           </span>
            
          </v-btn>
          <v-menu activator="#menu-activator">
          <v-list bg-color="secondary" rounded="lg">
              <v-list-item router to="profile" prepend-icon="mdi-badge-account">
                  <v-list-item-title class="text-body-2">Profile</v-list-item-title>
              </v-list-item>
              <v-list-item prepend-icon="mdi-logout" @click="confirmLogout = true">
                  <v-list-item-title class="text-body-2">Log out</v-list-item-title>
              </v-list-item>
          </v-list>
          </v-menu>
        </template>
        </v-app-bar>
        <v-main class="overflow-auto">
          <router-view/>
          <v-dialog
            v-model="loading"
            max-width="320"
            persistent
          >
            <v-list
              class="py-2"
              color="primary"
              elevation="12"
              rounded="lg"
            >
              <v-list-item
                title="Refreshing Application..."
              >
                <template v-slot:append>
                  <v-progress-circular
                    color="primary"
                    indeterminate="disable-shrink"
                    size="30"
                    width="4"
                  ></v-progress-circular>
                </template>
              </v-list-item>
            </v-list>
          </v-dialog>
      </v-main>
    </v-layout>
    
    <ChangeSemesterSchoolyearDlalog ref="ChangeSemesterSchoolyearDlalog" @refresh="refresh()"/>

    <v-dialog v-model="confirmLogout" width="450">
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-body-1">Are you sure you want to logout this account ?</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmLogout = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="logout()" color="red" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import ChangeSemesterSchoolyearDlalog from '../components/Dialogs/ChangeSemesterSchoolyearDlalog.vue';
import { defineComponent } from 'vue';
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
  name: 'MainView',
  components: {
    ChangeSemesterSchoolyearDlalog
  },
  data () {
      return {
        drawer: true,
        rail: false,
        userType: '',
        loading: false,
        confirmLogout: false,
        errored: false,
        currentTime: this.getCurrentDate(),
        notificationData: [],
        notificationCount: 0,
        notificationInterval: null
      }
  },
  computed: {
    currentImage() {
      return this.errored || !this.$store.state.user.picUrl
        ? require('@/assets/profile-pic.png')
        : this.$store.state.user.picUrl;
    }
  },
  watch: {
    isTabletOrPhone(newVal) {
      this.drawer = !newVal;
    }
  },
  methods: {
        logout(){
            localStorage.removeItem("vuex");
            localStorage.removeItem("aums-token");
            window.location.reload()
        },
        loadMenu(userType) {
          switch (userType) {
            case 1:
              this.userType = '/admin'
              break; 
          }
        },
        getCurrentDate(){
          const cur_date = new Date();
          const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];
          const day = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
          return day[cur_date.getDay()] + ' | ' + month[cur_date.getMonth()] + ' ' + cur_date.getDate() + ', '+ cur_date.getFullYear() + ' | ' + this.formatAMPM(cur_date);
        },
        formatAMPM(date) {
          var hours = date.getHours();
          var minutes = date.getMinutes();
          var seconds = date.getSeconds();
          var ampm = hours >= 12 ? 'pm' : 'am';
          hours = hours % 12;
          hours = hours ? hours : 12;
          minutes = minutes < 10 ? '0'+minutes : minutes;
          seconds = seconds < 10 ? '0'+seconds : seconds;
          var strTime = hours + ':' + minutes + ':' + seconds + ' ' + ampm;
          return strTime;
        },
        showChangeSemesterSchoolyearDialog(){
           this.$refs.ChangeSemesterSchoolyearDlalog.init()
        },
        changeRole(newRole) {
          this.$store.commit('UPDATE_ROLE', newRole);
          this.refresh()
        },
        refresh() {
          this.loading = true;
          setTimeout(() => {
            window.location.reload()
            this.loading = false;
          }, 2000);
        },
        onImageError() {
          this.errored = true;
        },
        async loadNotification(){
            const { showSnackbar } = useSnackbar()
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/notifications/findAllByUser/' + this.$store.state.user.id + '/' + this.$store.state.currentRole.id + '/' + this.$store.state.semester_schoolyear.id,
              { headers:
                  { 
                      'Authorization': `Bearer ${token}`,
                  }
              }
            )
            .then(res => {
                this.notificationData = res.data.notifications
                this.notificationCount = res.data.unreadCount
            })
            .catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        setupResizeListener() {
          const media = window.matchMedia("(max-width: 1024px)");
          const handler = (e) => {
            this.isTabletOrPhone = e.matches;
          }
          this.isTabletOrPhone = media.matches;
          media.addEventListener("change", handler);
          this._mediaHandler = { media, handler };
        },
        markedAsRead(notif){
            if(notif.marked_as_read) return;
            const notif_id = notif.id
            axios.patch(process.env.VUE_APP_SERVER_URL + '/notifications/markAsRead/' + notif_id,
              ).then((res)=>{
                  if(res.data.status == 200){
                      this.loadNotification()
                  }
              })
        },
    },
    mounted() {
        this.setupResizeListener();

        this.loadNotification();

        this.notificationInterval = setInterval(() => {
          this.loadNotification();
        }, 30000);
    },
    beforeUnmount() {
      if (this.notificationInterval) {
        clearInterval(this.notificationInterval);
      }
      if (this._mediaHandler) {
        this._mediaHandler.media.removeEventListener("change", this._mediaHandler.handler);
      }
    }
});
</script>
<style scoped>
@media (max-width: 767px) {
  .blur {
    display: none;
  }
}
.hide-scrollbar {
  /* Hide scrollbar for WebKit browsers (e.g., Chrome, Safari) */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.hide-scrollbar::-webkit-scrollbar {
  display: none; /* Hide scrollbar for WebKit browsers */
}

:deep(.solid-bg) {
  background-color: #ca8a04 !important;
  color: white !important;
}

:deep(.v-list-group--open) {
  background-color: #ffffff !important;
  color: black !important;
  border-radius: 10px;
}

.sidebar-content {
  max-height: calc(100vh - 0px); /* Adjust based on your header height */
  flex-grow: 1;
  overflow-y: auto;
}

.sticky-footer {
  position: sticky;
  bottom: 0;
  background: #105005; /* Adjust based on your theme */
  z-index: 10; /* Ensures it stays on top */
}

.sticky-header {
  position: sticky;
  top: 0;
  background: #105005;
  z-index: 20;
  display: block;
}
</style>
